import React, { Component, Fragment } from "react";
import moment from "moment";
import { Divider, Grid, Typography, FormControl, FormControlLabel, RadioGroup, Radio, Button } from "@material-ui/core";
import SaveIcon from "@material-ui/icons/Save";

import CustomAcordion from "../layout/CustomAcordion";
import LabeledTextField from "../layout/LabeledTextField";
import { showDateInTextType } from "../../services/utils/utils";
import Swal from "sweetalert2";
import "../../assets/css/deals.css";

const YesNoField = (props) => {
  return (
    <FormControl component="fieldset">
      <Grid container direction="row" alignItems="center" spacing={1}>
        <Grid item>
          <Typography variant="subtitle1" align="right">
            {props.label}
          </Typography>
        </Grid>
        <Grid item>
          <RadioGroup row name={props.name} value={Boolean(props.value).toString()} onChange={props.onChange}>
            <FormControlLabel value={"true"} control={<Radio color="primary" />} label="כן" labelPlacement="end" />
            <FormControlLabel value={"false"} control={<Radio color="primary" />} label="לא" labelPlacement="end" />
          </RadioGroup>
        </Grid>
      </Grid>
    </FormControl>
  );
};

class DealManageContainer extends Component {
  render() {
    return (
      <Grid className="deal-manage" container direction="column" spacing={0}>
        <Grid className="pre-calc-sections" container item xs={12} direction="column" wrap="nowrap">
          <CustomAcordion defaultExpanded summaryText="כללי">
            <Grid container direction="column" spacing={2}>
              <Grid item>
                <LabeledTextField
                  type="text"
                  name="dealDescription"
                  assistantPath="deals.manage.dealDescription"
                  value={this.props.dealDescription}
                  label="תיאור העסקה"
                  textFieldWidth={320}
                  onChange={this.props.handleManageOnChange}
                />
              </Grid>
              {this.props.isFullManageComponent ? (
                <Fragment>
                  <Grid item>
                    <Grid className="deal-manage-row" container direction="row" alignItems="center">
                      <Grid item>
                        <LabeledTextField
                          disabled
                          type="date"
                          name="dealDate"
                          value={this.props.dealDate}
                          label="תאריך חתימת ההסכם"
                          textFieldWidth={170}
                          onChange={this.props.handleManageOnChange}
                        />
                      </Grid>
                      <Grid item>
                        <YesNoField
                          name="hasEaaratAzhara"
                          label="האם נרשמה הערת אזהרה?"
                          value={this.props.hasEaaratAzhara}
                          onChange={this.props.handleManageOnChange}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item>
                    <Grid className="deal-manage-row" container direction="row" alignItems="center">
                      <Grid item>
                        <YesNoField
                          name="hasMasShevachReportsSubmitted"
                          label="האם הוגשו דיווחי מס שבח?"
                          value={this.props.hasMasShevachReportsSubmitted}
                          onChange={this.props.handleManageOnChange}
                        />
                      </Grid>
                      {this.props.dealDate ? (
                        <Grid item>
                          <Typography className="deal-manage-deadline" variant="subtitle1" align="right">
                            תאריך אחרון להגשת דיווחים:
                            <strong>{` ${this.getLastDateForSubmittion()}`}</strong>
                          </Typography>
                        </Grid>
                      ) : null}
                    </Grid>
                  </Grid>
                  <Grid className="pre-calc-divider" item>
                    <Divider light />
                  </Grid>
                  <Grid item>
                    <Typography className="deal-manage-section-title" variant="subtitle1" align="right">
                      אישורי מיסים
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Grid className="deal-manage-row" container direction="row" alignItems="center">
                      <Grid item>
                        <YesNoField
                          name="masShavach"
                          label="מס שבח"
                          value={this.props.masShavach}
                          onChange={this.props.handleManageOnChange}
                        />
                      </Grid>
                      <Grid item>
                        <YesNoField
                          name="masRechisha"
                          label="מס רכישה"
                          value={this.props.masRechisha}
                          onChange={this.props.handleManageOnChange}
                        />
                      </Grid>
                      <Grid item>
                        <YesNoField
                          name="haitelHashbacha"
                          label="היטל השבחה"
                          value={this.props.haitelHashbacha}
                          onChange={this.props.handleManageOnChange}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Fragment>
              ) : null}
              <Grid className="pre-calc-actions" item container direction="row" spacing={2}>
                <Grid item>
                  <Button
                    endIcon={<SaveIcon style={{ marginRight: "8px" }} />}
                    variant="contained"
                    color="secondary"
                    onClick={this.validateDealDescriptionAndUpdate}
                  >
                    שמירה
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </CustomAcordion>
        </Grid>
      </Grid>
    );
  }

  validateDealDescriptionAndUpdate = () => {
    if (!this.props.dealDescription || this.props.dealDescription.length < 2) {
      Swal.fire("תיאור עסקה צריך להיות לפחות 2 תווים", "", "info");
      return;
    }
    this.props.updateDealData();
  };

  getLastDateForSubmittion() {
    const today = new Date(this.props.dealDate);
    today.setDate(today.getDate() + 30);
    return showDateInTextType(moment(today).format("YYYY-MM-DD"));
  }
}

export default DealManageContainer;
